import React from "react"
import { Rating } from "react-simple-star-rating"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import { breakpoint } from "../../configs/utilities"
import {
  SectionTitle,
  SectionText,
} from "../../components/common/typography/Typography"
import reviewGoogle from "../../assets/mover/reviewGoogle.png"
import reviewYelp from "../../assets/mover/reviewYelp.png"
import reviewBbb from "../../assets/mover/reviewBbb.png"

const ReviewSection = ({
  description,
  google_average_review,
  yelp_average_review,
  bbb_rating,
}) => {
  return (
    <Wrapper>
      <SectionWrapper paddingSm="30px 20px" paddingXl="40px 100px">
        <SectionTitle>Review</SectionTitle>
        <SectionText>{description}</SectionText>
        <Reviews>
          <SingleReview>
            <img
              src={reviewGoogle}
              alt="google review"
              width="70"
              height="23.5"
            />
            <Rating
              readonly={true}
              initialValue={google_average_review}
              allowFraction={true}
              size={20}
              fillColor="#CFA448"
            />
            <span>{google_average_review}</span>
          </SingleReview>
          <SingleReview>
            <img src={reviewYelp} alt="yelp review" width="70" height="29" />
            <Rating
              readonly={true}
              initialValue={yelp_average_review}
              allowFraction={true}
              size={20}
              fillColor="#CFA448"
            />
            <span>{yelp_average_review}</span>
          </SingleReview>
          <SingleReview>
            <img src={reviewBbb} alt="bbb review" width="70" height="26.5" />
            <Rating
              readonly={true}
              initialValue={bbb_rating}
              allowFraction={true}
              size={20}
              fillColor="#CFA448"
            />
            <span>{bbb_rating}</span>
          </SingleReview>
        </Reviews>
      </SectionWrapper>
    </Wrapper>
  )
}

export default ReviewSection

const Wrapper = styled.div``

const Reviews = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 30px;
  margin-top: 30px;

  @media screen and (min-width: ${breakpoint.md}) {
    flex-direction: row;
    column-gap: 100px;
    margin-top: 50px;
  }
`

const SingleReview = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 100%;
    max-width: 70px;
  }

  span {
    font-size: 20px;
    font-weight: 700;
  }
`
